import { FileOutlined } from '@ant-design/icons';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { type RichiestaModuloDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaModuloDTO.ts';
import { Link } from '@framework/ui/core/router/TypedRoute.tsx';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { SubmissionLogic } from '../../SubmissionLogic.ts';
import { useSummaryModuleLink } from './SummaryModuleLinkContext.tsx';

interface IGoToModuleButtonProps {
  submissionId: string;
  module: RichiestaModuloDTO;
  submission?: RichiestaDTO;
}

/**
 * Pulsante solo-icona per navigare al modulo.
 * Disabilitato se la richiesta è nuova o il modulo non è stato visitato.
 */
export function GoToModuleButton(props: IGoToModuleButtonProps) {
  const { submissionId, module, submission } = props;
  const { t } = useTranslation();
  const getModuleLink = useSummaryModuleLink();

  // La rotta del modulo arriva esclusivamente dal context: ogni app (FO/BO)
  // fornisce la propria. In assenza di link la navigazione è disabilitata.
  const moduleLink = getModuleLink?.(submissionId, module.id ?? '');

  const isDisabled =
    SubmissionLogic.isSubmissionNew(submission) ||
    !module.statoValidazione?.visitato ||
    moduleLink == null;

  const disabledTooltip = t(
    'form.salva-modulo-download-pdf',
    'Salva il modulo almeno una volta per scaricare il documento PDF',
  );
  const goToModuleText = t('submission-summary.vai-al-modulo', 'Vai al modulo');

  return (
    <Tooltip title={isDisabled ? disabledTooltip : goToModuleText}>
      {isDisabled || !moduleLink ? (
        <Button
          icon={<FileOutlined aria-label={disabledTooltip} />}
          disabled
          size="small"
          type="link"
        />
      ) : (
        <Link to={moduleLink}>
          <Button
            icon={<FileOutlined aria-label={goToModuleText} />}
            size="small"
            type="link"
          />
        </Link>
      )}
    </Tooltip>
  );
}
